export default [

    {
        path: 'reportes',
        name: 'empresa.reportes',
        component: () => import('@/views/empresa/reportes/EmpresaReportesLayout.vue'),
        children:
            [
                {
                    path: 'ventas/resumen',
                    name: 'empresa.ventas.resumen',
                    component: () => import('@/views/empresa/ventas/VentasEmpresaResumen.vue'),
                },
                {
                    path: 'ventas/comparativo-mes',
                    name: 'empresa.ventas.comparativo.mes',
                    component: () => import('@/views/empresa/reportes/EmpresaReporteVentaPorMes.vue'),
                },

                {
                    path: 'ventas/diario',
                    name: 'empresa.ventas.resumen.diario',
                    component: () => import('@/views/empresa/ventas/reporte/ResumenDiarioVenta.vue')
                },

                {
                    path: 'ventas/conciliacion',
                    name: 'empresa.ventas.conciliacion',
                    component: () => import('@/views/empresa/contabilidad/reporte/ReporteVentaConciliacion.vue')
                },
                {
                    path: 'contabilidad/cuenta-contable',
                    name: 'empresa.contabilidad.cuenta-contable',
                    component: () => import('@/views/empresa/contabilidad/reporte/ReporteCuentaContable.vue')
                },
                

                {
                    path: 'contabilidad/balance-mensual',
                    name: 'empresa.contabilidad.balance-mensual',
                    component: () => import('@/views/empresa/contabilidad/reporte/balance/mensual/ReporteBalanceMensual.vue')
                },
                {
                    path: 'compras/mensual',
                    name: 'empresa.compras.mensual',
                    component: () => import('@/views/empresa/compras/reporte/ReporteCompraMensual.vue')
                },
                {
                    path: 'compras/proveedor',
                    name: 'empresa.compras.proveedor',
                    component: () => import('@/views/empresa/compras/reporte/ReporteCompraPorProveedor.vue')
                },
                {
                    path: 'general/resultado',
                    name: 'empresa.general.resultados',
                    component: () => import('@/views/empresa/reportes/ReporteEstadoResultado.vue')
                },
                {
                    path: 'gastos',
                    name: 'empresa.gastos',
                    component: () => import('@/views/empresa/gastos/reporte/ReporteGastos.vue')
                }, 
                {
                    path: 'gastos/detalle',
                    name: 'empresa.gastos.detalle',
                    component: () => import('@/views/empresa/gastos/reporte/ReporteGastosDetalle.vue')
                },
                {
                    path: 'general/flujo-caja',
                    name: 'empresa.general.flujo-caja',
                    component: () => import('@/views/empresa/reportes/ReporteFlujoCaja.vue')
                }






            ]

    }
]